
import { configureStore } from '@reduxjs/toolkit';
import { tasksReducer, filterReducer } from './reducer';

const store = configureStore({
    reducer: {
        tasks: tasksReducer,
        filters: filterReducer,
    },
});

export { store };
